/* ==========================================================================
   WarGrounds — pages de gamme

   Les tailles défilent désormais horizontalement sur mobile (lot 8). Quand on
   arrive sur une page filtrée, la puce active peut se trouver hors du champ
   visible : rien n'indique alors quel filtre est appliqué. On la ramène dans
   la vue, sans animation et sans toucher au défilement vertical de la page.

   Pour tout annuler : retirer la ligne script dans wg-mobile-cro.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function recentrer() {
    var piste = document.querySelector('.wg-sizes');
    if (!piste) return;
    /* Uniquement quand la piste défile réellement : sur grand écran les puces
       tiennent sur une ligne et il n'y a rien à recentrer. */
    if (piste.scrollWidth <= piste.clientWidth + 4) return;

    var active = piste.querySelector('.wg-size.is-active');
    if (!active) return;

    var d = active.offsetLeft - piste.clientWidth / 2 + active.offsetWidth / 2;
    piste.scrollLeft = Math.max(0, d);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recentrer);
  } else {
    recentrer();
  }
})();
